import { render } from "./ServerDisplay.vue?vue&type=template&id=47acb40c&ts=true"
import script from "./ServerDisplay.vue?vue&type=script&lang=ts"
export * from "./ServerDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__